import api from '@/services/api/api';
import { useQuery } from '@tanstack/react-query';

const useGetUser = (userEmail: string | undefined | null) => {
  return useQuery({
    queryKey: ['user', { userEmail }],
    queryFn: () => api.user.getUser(),
    enabled: !!userEmail
  });
};

export default useGetUser;
